import * as getters from './getters'
import * as actions from './actions'
import requestSituation from "@/enum/request-situation";
import itemType from "@/enum/item-type";
import itemStatus from "@/enum/item-status";
import uniqid from "uniqid";
const SET_ITEM_IMAGE = 'set_item_image'
const SET_ITEM_IMAGE_BY_ISBN = 'set_item_image_by_isbn'
const SET_ITEM_TITLE = 'set_item_title'
const SET_ITEM_DESCRIPTION = 'set_item_description'
const SET_ITEM_AUTHOR = 'set_item_author'
const SET_ITEM_SYNOPSIS = 'set_item_synopsis'
const SET_ITEM_ISBN_IMAGE_LINK = 'set_item_isbn_image_link'
const SET_ITEM_ISBN = 'set_item_isbn'
const SET_ITEM_TYPE = 'set_item_type'
const SET_ITEM_PAYMENT_TYPE = 'set_item_payment_type'
const SET_ITEM_PAYMENT_VALUES = 'set_item_payment_values'
const SET_ITEM_CATEGORY = 'set_item_category'
const SET_ITEM_CONDITION = 'set_item_condition'
const SET_IMAGE_FILE = 'set_image_file'
const SET_IMAGE_ORIENTATION = 'set_item_image_orientation'
const ITEM_PROFILE = 'item_profile'
const RESET_NEW_ITEM = 'reset_new_item'
const UPDATED_ITEM = 'updated_item'
const UPDATE_ITEM = 'update_item'
const SEARCH_ITEMS = 'search_items'
const USER_INVENTORY = 'user_inventory'
const SEARCH_RESULT = "search_result"
const SEARCH_QUERY = "search_query"
const CLEAR_SEARCH = "clear_search"
const SEARCH_AUTOCOMPLETE = "search_autocomplete"
const ITEM_MESSAGES = "item_messages"
const ITEM_POST_MESSAGES = "item_post_messages"
const POST_ITEM_RESPONSE = "post_item_response"
const SET_ITEM_REQUESTS_MADE = "set_item_requests_made"
const SET_ITEM_REQUESTS_RECEIVED = "set_item_requests_received"
const SET_NEW_ITEM_GROUPS = "set_new_item_groups"
const RESET_ITEM_IMAGE = 'reset_item_image'
const RESET_ITEM_ISBN_IMAGE = 'reset_item_isbn_image'
const SET_NEW_ITEM_STEP = 'set_new_item_step'
const REMOVE_NEW_ITEM_AT_GROUP = 'remove_new_item_at_group'
const SET_ITEM_MY_GROUPS = 'set_item_my_groups'
const SET_INVENTORY_REQUESTS = 'set_inventory_requests'
const SET_INTERESTED = 'set_interested'
const SET_ACTIVITY_NOTIFICATION = 'set_activity_notification'
const MERGE_REQUESTS_RECEIVED_MADE = 'merge_requests_received_made'
const UPDATE_ITEM_STATUS = 'update_item_status'
const RANDOM_ITEMS = 'random_items'
const IS_FETCHING_ACTIVITY_PAGE = 'is_fetching_activity_page'
const initialState = {
    new_item: {
        title: '',
        description: '',
        image: '',
        image_orientation: 1,
        type: 0,
        payment_type: [],
        payment_value: 0,
        category: 0,
        condition: 0,
        ship: 0,
        subcategory: 0,
        points: 0,
        cash: 0,
        free: "",
        atGroupsIds: [],
        atGroups: [],
        availableOnlyToGroups: true,
        status: 0,
        author: "",
        synopsis: "",
        isbn_code: "",
        isbn_image_link: "",
    },
    item_search_results: [],
    item_search_query: null,
    image_file: '',
    item_profile: {},
    updated_item: {},
    user_inventory: [],
    search_result: [],
    search_autocomplete: [],
    item_messages: [],
    post_item_response: {},
    item_requests_made: {},
    item_requests_received: [],
    atGroups: [],
    itemStep: null,
    inventory_with_requests: [],
    item_interested: {},
    activity_notifications: [],
    merged_requests: [],
    random_items: [],
    is_fetching_activity_page: true,
}

const mutations = {
    [SET_INTERESTED](state, { item }) {
        state.item_interested = item;
    },
    [RESET_ITEM_IMAGE](state) {
        state.new_item.image = '';
        state.image_file = '';
        state.new_item.isbn_image_link = '';
    },
    [RESET_ITEM_ISBN_IMAGE](state) {
        state.new_item.isbn_image_link = '';
    },
    [SET_ITEM_IMAGE](state, payload) {
        state.new_item.image = payload
    },
    [SET_ITEM_IMAGE_BY_ISBN](state, payload) {
        state.new_item.isbn_image_link = payload
    },
    [SET_ITEM_TITLE](state, payload) {
        state.new_item.title = payload
    },
    [SET_ITEM_DESCRIPTION](state, payload) {
        state.new_item.description = payload
    },
    [SET_ITEM_AUTHOR](state, payload) {
        state.new_item.author = payload
    },
    [SET_ITEM_SYNOPSIS](state, payload) {
        state.new_item.synopsis = payload
    },
    [SET_ITEM_ISBN](state, payload) {
        state.new_item.isbn_code = payload
    },
    [SET_ITEM_ISBN_IMAGE_LINK](state, payload) {
        state.new_item.isbn_image_link = payload
    },
    [SET_ITEM_TYPE](state, payload) {
        state.new_item.type = payload
    },
    [SET_ITEM_PAYMENT_TYPE](state, payload) {
        if (Array.isArray(payload)) {
            state.new_item.payment_type = payload.map(value => { return value });
        } else {
            state.new_item.payment_type = payload;
        }
    },
    [SET_ITEM_PAYMENT_VALUES](state, payload) {
        state.new_item.cash = payload.cash
        state.new_item.points = payload.points
        state.new_item.free = payload.free
    },
    [SET_ITEM_CATEGORY](state, payload) {
        state.new_item.category = payload
    },
    [SET_ITEM_CONDITION](state, payload) {
        state.new_item.condition = payload
    },
    [SET_IMAGE_FILE](state, payload) {
        state.image_file = payload;
        state.new_item.image_file = payload;
    },
    [SET_IMAGE_ORIENTATION](state, payload) {
        state.new_item.image_orientation = payload
    },
    [ITEM_PROFILE](state, payload) {
        state.item_profile = payload
    },
    [RESET_NEW_ITEM](state) {
        state.new_item.title = ''
        state.new_item.description = ''
        state.new_item.image = ''
        state.new_item.image_orientation = 1
        state.new_item.type = 0
        state.new_item.payment_type = []
        state.new_item.payment_value = 0
        state.new_item.category = 0
        state.new_item.condition = 0
        state.new_item.ship = 0
        state.new_item.subcategory = 0
        state.new_item.points = 0
        state.new_item.cash = 0
        state.new_item.free = ''
        state.new_item.availableOnlyToGroups = true;
        state.image_file = ''
        state.item_profile = {}
    },
    [UPDATED_ITEM](state, update) {
        for (let key in update) {
            if (update[key] !== null) {
                state.updated_item[key] = update[key]
            } else {
                state.updated_item[key] = state.item_profile[key]
            }
        }
    },
    [UPDATE_ITEM](state, update) {
        update = update.item
        for (let key in update) {
            state.item_profile[key] = update[key]
        }
    },

    [SEARCH_ITEMS](state, payload) {
        state.item_search_results = payload
    },

    [USER_INVENTORY](state, payload) {
        state.user_inventory = payload
    },
    [SEARCH_QUERY](state, query) {
        state.item_search_query = query;
    },
    [CLEAR_SEARCH](state) {
        state.search_result = [];
    },
    [SEARCH_RESULT](state, { result, query }) {
        state.item_search_query = query;
        state.search_result = [];
        state.search_result = result;
    },
    [SEARCH_AUTOCOMPLETE](state, { result }) {
        state.search_autocomplete = [];
        state.search_autocomplete = result;
    },
    [ITEM_MESSAGES](state, payload) {
        state.item_messages = payload;
    },
    [ITEM_POST_MESSAGES](state, payload) {
        state.item_messages.push(payload);
    },
    [POST_ITEM_RESPONSE](state, response) {
        state.post_item_response = response;
    },
    [SET_ITEM_REQUESTS_MADE](state, payload) {
        state.item_requests_made = payload;
    },
    [SET_ITEM_REQUESTS_RECEIVED](state, payload) {
        state.item_requests_received = payload;
    },
    [SET_NEW_ITEM_GROUPS](state, { groups, groupsId }) {
        state.atGroups = groups;
        state.new_item.atGroupsIds = groupsId;
    },
    [SET_NEW_ITEM_STEP](state, { step }) {
        state.itemStep = step;
    },
    [REMOVE_NEW_ITEM_AT_GROUP](state, { index }) {
        state.atGroups.splice(index, 1);
        state.new_item.atGroupsIds.splice(index, 1);
    },
    [SET_ITEM_MY_GROUPS](state, { availableOnlyToGroups }) {
        state.new_item.availableOnlyToGroups = availableOnlyToGroups;
    },
    [SET_INVENTORY_REQUESTS](state, { inventory }) {
        state.inventory_with_requests = [];

        inventory.forEach(item => {
            item.requests = [];
            state.item_requests_received.forEach(request => {
                if (request.itemId === item.id) {
                    delete request.item;
                    item.requests.push(request);
                }
            })
            state.inventory_with_requests.push(item);
        })
        if (state.item_requests_made && Object.keys(state.item_requests_made).length > 0) {
            state.merged_requests = state.item_requests_made ? [...state.item_requests_made] : []
        } else if (state.inventory_with_requests && Object.keys(state.inventory_with_requests).length > 0) {
            state.merged_requests = state.inventory_with_requests ? [...state.inventory_with_requests] : []
        }
    },
    [MERGE_REQUESTS_RECEIVED_MADE](state) {
        if (state.item_requests_made && state.item_requests_received) {
            state.merged_requests = [...state.item_requests_made, ...state.item_requests_received];
        } else {
            state.merged_requests = [];
        }

    },
    [SET_ACTIVITY_NOTIFICATION](state) {
        let merged_received = [];
        let merged_made = [];
        let accepted = [];
        let pending = [];
        let pending_received = [];
        let pending_made = [];
        let newRequest = [];
        let rejected = [];
        let result = [];

        const requests_received = state.item_requests_received || [];
        merged_received = [...requests_received];
        merged_made = [...state.item_requests_made];
        newRequest = merged_received.filter((request) => {
            if (request.situation === requestSituation.OPEN) {
                return request;
            }
        });
        newRequest = newRequest.map((item) => {
            return {
                ...item,
                notification: "new-request",
                _uId: uniqid()
            };
        });
        accepted = merged_made.filter((request) => {
            if (request.situation === requestSituation.ACCEPTED) {
                return request;
            }
        });
        accepted = accepted.map((item) => {
            return {
                ...item,
                notification: "accepted",
                _uId: uniqid()
            };
        });
        pending_received = merged_received.filter((request) => {
            let d = new Date(request.changeSituationAt);
            let today = new Date();
            let canBeSent = false;
            let requestIsValid = request ? request.item : null;
            if (!requestIsValid) return;
            if (
                request.item.type &&
                (request.item.type === itemType.GIVE ||
                    request.item.type === itemType.LEND)
            ) {
                d.setDate(d.getDate() + 10);
            } else {
                d.setDate(d.getDate() + 20);
                if (request.item.status === itemStatus.SENT) {
                    canBeSent = true;
                }
            }
            if (
                request.situation === requestSituation.ACCEPTED &&
                today >= d &&
                (request.item.status === itemStatus.WAITING || canBeSent)
            ) {
                return request;
            }
        });
        pending_made = merged_made.filter((request) => {
            let d = new Date(request.changeSituationAt);
            let today = new Date();
            let canBeSent = false;
            let requestIsValid = request ? request.item : null;
            if (!requestIsValid) return;
            if (
                request.item.type &&
                (request.item.type === itemType.GIVE ||
                    request.item.type === itemType.LEND)
            ) {
                d.setDate(d.getDate() + 20);
                if (request.item.status === itemStatus.SENT) {
                    canBeSent = true;
                }
            } else {
                d.setDate(d.getDate() + 10);
            }
            if (
                request.situation === requestSituation.ACCEPTED &&
                today >= d &&
                (request.item.status === itemStatus.WAITING || canBeSent)
            ) {
                return request;
            }
        });
        pending = [...pending_received, ...pending_made]
        pending = pending.map((item) => {
            return {
                ...item,
                notification: "pending",
                _uId: uniqid()
            };
        });
        rejected = merged_made.filter((request) => {
            if (request.situation === requestSituation.REJECTED) {
                return request;
            }
        })
        rejected = rejected.map((item) => {
            return {
                ...item,
                notification: "rejected",
                _uId: uniqid()
            }
        })
        result = [...newRequest, ...pending, ...accepted, ...rejected];
        result = result.sort((a, b) => {
            return new Date(b.createdAt) - new Date(a.createdAt);
        });
        state.activity_notifications = result;
    },
    [UPDATE_ITEM_STATUS](state, { item }) {

        const itemId = item.id;
        const status = item.status;

        state.merged_requests.forEach((i) => {
            if (i.itemId && itemId === i.itemId) {
                i.item.status = status;
            } else if (i.id === itemId) {
                i.status = status;
            }
        });
        state.inventory_with_requests.forEach((i) => {
            if (i.itemId && itemId === i.itemId) {
                i.item.status = status;
            } else if (i.id === itemId) {
                i.status = status;
            }
        });
    },
    [RANDOM_ITEMS](state, result) {
        state.random_items = [];
        state.random_items = result;
    },
    [IS_FETCHING_ACTIVITY_PAGE](state, value) {
        state.is_fetching_activity_page = value
    },
}

export default {
    state: {...initialState },
    actions,
    getters,
    mutations
}
